import { LoginCodeChannelEnum } from '@alice-financial/alice-sdk'
import { Box, Button, Grid, TextFieldController, Typography } from '@alice-financial/pretext-ui'
import React from 'react'
import { Control } from 'react-hook-form'
import { FormattedMessage, useIntl } from 'react-intl'

type LoginFormValues = {
  requestCodeTarget: string
  verificationCode: string
}

type PhoneVerificationFormProps = {
  control: Control<LoginFormValues>
  onSubmit: () => void
  onReset: () => void
  channel: LoginCodeChannelEnum | null
  prettyTel: string | null
  aliceTel: string | null
}

/**
 * Pure component for phone verification code entry
 * Displays code sent message and verification code input
 */
export const PhoneVerificationForm: React.FC<PhoneVerificationFormProps> = ({
  control,
  onSubmit,
  onReset,
  channel,
  prettyTel,
  aliceTel,
}) => {
  const intl = useIntl()

  return (
    <Box mb={3} component="form" onSubmit={onSubmit}>
      <Grid container spacing={2} justifyContent="center">
        <Grid size={12}>
          <Typography variant="body2" gutterBottom>
            <FormattedMessage
              id={
                channel === LoginCodeChannelEnum.Email
                  ? 'auth.login.code_sent_email'
                  : 'auth.login.code_sent_sms'
              }
              values={{ tel: prettyTel }}
            />
          </Typography>
          <Box mb={3}>
            <Button variant="outlined" onClick={onReset}>
              <FormattedMessage id="auth.login.get_new_code" />
            </Button>
          </Box>
          {aliceTel && (
            <Typography variant="body2">
              <FormattedMessage id="auth.login.opt_back_in" values={{ aliceTel }} />
            </Typography>
          )}
        </Grid>
        <Grid size={12}>
          <TextFieldController
            control={control}
            name="verificationCode"
            label={<FormattedMessage id="auth.login.verification_code" />}
            required
            fullWidth
            type="text"
            autoComplete="one-time-code"
            slotProps={{ htmlInput: { maxLength: 6 } }}
            rules={{
              required: true,
              minLength: {
                value: 6,
                message: intl.formatMessage({ id: 'common.validation.minlength' }, { minLength: 6 }),
              },
            }}
          />
        </Grid>
        <Box component={Grid} size={6}>
          <Button variant="contained" type="submit" fullWidth>
            <FormattedMessage id="auth.login.do_login" />
          </Button>
        </Box>
      </Grid>
    </Box>
  )
}
